import BurgerMenu from '../components/hamburger';
import Header from '../components/header';
import HoverEffect from '../components/hover-effect';
import CookieBar from '../components/cookie-bar';
import Modal from '../components/modal';
import Milestones from '../components/milestones';
import Newsblock from '../components/news-block';
import Animation from '../components/animation';
import Responsive from '../components/responsive';
import ToggleBox from '../components/toggle-box';
import StepByStep from '../components/step-by-step';
import Accordion from '../components/accordion';
import triggerEvent from '../components/tracking'; // Prepared for GA events tracking

export default {
  init() {
    this.Header = new Header();
    this.CookieBar = new CookieBar();
    this.HoverEffect = new HoverEffect();
    this.BurgerMenu = new BurgerMenu();
    this.Modal = new Modal();
    this.Milestones = new Milestones();
    this.Newsblock = new Newsblock();
    this.Animation = new Animation();
    this.Responsive = new Responsive();
    this.ToggleBox = new ToggleBox();
    this.StepByStep = new StepByStep();
    this.Accordion = new Accordion();
    this.addEvents();
    this.modifyDOM();
  },

  addEvents() {
  },

  modifyDOM() {
  },
};
